import { stringify, parse } from "qs"

export const stringifyQuery = (query, options) =>
	stringify(query, { arrayFormat: "brackets", addQueryPrefix: true, ...options })
export const parseQuery = query => parse(query, { ignoreQueryPrefix: true })
